import { Mobile } from '../../utils'

const parseToBoolean = bool => bool && bool.toLowerCase() === 'true' ? true : false
const state = {
  applicationLoading: true,
  botAccountData: {
    extras: {},
  },
  openImageInFrame: false,
}

const getters = {
  displayName: (state) => state.botAccountData.extras['blipchat-display-name'] || state.botAccountData.fullName,
  botAccountData: (state) => state.botAccountData,
  showAttachmentInput: (state) => parseToBoolean(state.botAccountData.extras['blipchat-receive-files'])
    && !Mobile.isKitKatWebview(),
  showRecordAudio: (state) => parseToBoolean(state.botAccountData.extras['blipchat-record-audio'])
      && !Mobile.isKitKatWebview(),
  hidePowered: (state) => parseToBoolean(state.botAccountData.extras['blipchat-hide-powered']),
  authenticadedMedias: (state) => parseToBoolean(state.botAccountData.extras['blipchat-authenticated-medias']),
  openImageInFrame: (state) => parseToBoolean(state.botAccountData.extras['blipchat-open-image-in-frame'])
   || state.openImageInFrame,
}

const mutations = {
  setApplicationLoading(state, isLoading) {
    state.applicationLoading = isLoading
  },
  setBotAccountData(state, botAccountData) {
    state.botAccountData = botAccountData
  },
  setOpenImageInFrame(state, isOpenImageInFrame) {
    state.openImageInFrame = isOpenImageInFrame
  },
}

export default {
  state,
  getters,
  mutations,
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/store/modules/app.ts